import React from "react";
import { Col, Row } from "react-bootstrap";
import RMCard from "../../components/rmCard";

const CustomerDetails = ({ customerData }) => {
  return (
    <Row>
      <Col xs="12" className="product-container">
        <RMCard />
      </Col>
      <Col xs="12" className="product-container">
        <div className="summary-card">
          <div className="side-card-title">Customer Details</div>
          <div className="side-card-value">
            Name: {`${customerData.name}`}
          </div>
          <div className="side-card-value">Email : {customerData.email_id}</div>
          <div className="side-card-value">
            Phone Number: {customerData.contact}
          </div>
        </div>
      </Col>
      {customerData.pincode && (
        <Col xs="12" className="product-container">
          <div className="summary-card">
            <div className="side-card-title">Address</div>
            <div className="side-card-value">
              {`${customerData.address}, ${customerData.state}, ${customerData.city}, ${customerData.pincode}`}
            </div>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default CustomerDetails;
